import styled from "styled-components";
import { staticContentPath } from "common/static_content_common";
import VideoPlay from "components/common/video/VideoPlay";
import { SOURCE_TYPE_VALUES } from "constant/panel";
import { PlaySource, SourceType } from "type/panel/Panel.type";
import { useEffect } from "react";
import {
  AreaSource,
  elDimensionsGetById,
  playAreaIdGet,
} from "components/pages/PlayPanel/PlayPanel.logic";

type Props = {
  contentSource: AreaSource;
  playMapInd: number;
  areaInd: number;
  onElapse: Function;
};

const PlaySourceContent = ({
  contentSource,
  playMapInd,
  areaInd,
  onElapse,
}: Props) => {
  useEffect(() => {
    setTimeout(() => {
      onElapse();
    }, contentSource.duration * 1000);
  }, []);

  const sourceType: SourceType = contentSource.type as SourceType;
  let playContent = <>playArea</>;
  const playAreaId: string = playAreaIdGet(playMapInd, areaInd);
  const areaDimensions: any = elDimensionsGetById(playAreaId);
  const filePath: string =
    typeof contentSource.fileName !== "undefined" &&
    contentSource.fileName !== ""
      ? staticContentPath(contentSource.fileName)
      : "";
  if (sourceType === SOURCE_TYPE_VALUES.VIDEO) {
    let videoPlayWidth: number = 500;
    let currentTime: number = 0;

    if (areaDimensions.offsetWidth) {
      videoPlayWidth = areaDimensions.offsetWidth;
    }

    // if (contentSource.start) {
    //   currentTime = contentSource.start;
    // }

    playContent = (
      <VideoPlay
        filePath={filePath}
        autoPlay={true}
        muted={true}
        width={videoPlayWidth}
        loop
        currentTime={currentTime}
      />
    );
  } else if (sourceType === SOURCE_TYPE_VALUES.PHOTO) {
    playContent = <img src={filePath} width="100%" />;
  } else if (sourceType === SOURCE_TYPE_VALUES.TEXT) {
    playContent = <TextDiv>{contentSource.content}</TextDiv>;
  }
  return playContent;
};

const TextDiv = styled.div`
  font-size: 2rem;
  line-height: 2.5rem;
  padding: 1rem;
  color: white;
  font-weight: bold;
  // background-color: FloralWhite;
  background-color: transparent;
  text-shadow: 1px 1px 2px yellow;
`;

export default PlaySourceContent;
